import './polyfill';
import { hijackLink } from "./hijack/link";
import { getGlobalLightHub } from "./utils";
import { navigateTo, registerNavigation } from "./nav";
import { patchRaxDOM } from "./patch";
import { GlobalLightHub, Page } from './typing';
import { api } from './api';
import { logger } from './logger';

// @ts-ignore
import _Promise from './promise';


export function init() {
    if (!getGlobalLightHub().inited) {
        const lighthub = getGlobalLightHub();

        // @ts-ignore
        Promise = _Promise;

        let globalPromise = lighthub.origins._Promise;
        if (typeof globalPromise !== 'function') {
            // polyfill Promise
            globalPromise = _Promise;
        }

        // guard promise
        Object.defineProperty(window, 'Promise', {
            get() {
                return globalPromise;
            },
            set(val) {
                console.warn('[Warn] LightHub prevent duplicate polyfill of Promise');
            }
        });

        registerNavigation();

        lighthub.inited = true;

        


        // hijackLink();


        lighthub.hooks = lighthub.hooks || {};
        lighthub.globalExposedKey = lighthub.globalExposedKey || [];
        lighthub.globalIgnoreScript = lighthub.globalIgnoreScript || [];
        lighthub.pages = lighthub.pages || [];
        lighthub.hooks = lighthub.hooks || {};
        lighthub.asyncQueueId = lighthub.asyncQueueId || 0;

        lighthub.api = api;

        patchRaxDOM();
    }
    const lighthub = getGlobalLightHub();

    return {
        ...lighthub.api,
        origins: lighthub.origins,
    };
}


export default init;

export type LightHubInit = typeof init;

export { api };

export function exist() {
    // @ts-ignore
    return window._LIGHTHUB ? true: false;
}

